import React, { Fragment } from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer, Tooltip } from 'recharts';
import { colors } from '../../utils/portfolioData';
// Modern blue/purple color scheme with milky glass aesthetic
const data = [{
  name: 'Bitcoin',
  value: 51.23,
  color: '#8B5CF6',
  glowColor: 'rgba(139, 92, 246, 0.6)'
}, {
  name: 'Ethereum',
  value: 24.87,
  color: '#6366F1',
  glowColor: 'rgba(99, 102, 241, 0.6)'
}, {
  name: 'USDT',
  value: 15.45,
  color: '#3B82F6',
  glowColor: 'rgba(59, 130, 246, 0.6)'
}, {
  name: 'Solana',
  value: 5.78,
  color: '#A78BFA',
  glowColor: 'rgba(167, 139, 250, 0.6)'
}, {
  name: 'BNB',
  value: 2.67,
  color: '#818CF8',
  glowColor: 'rgba(129, 140, 248, 0.6)'
}];
export function AllocationChart() {
  const stablecoins = ['USDT', 'USDC'];
  const investedPercent = data.filter(d => !stablecoins.includes(d.name)).reduce((sum, d) => sum + d.value, 0);
  return <div className="h-full flex flex-col" data-id="element-590">
      <div className="flex items-center justify-between mb-6" data-id="element-591">
        <h3 className="text-base font-heading text-text-primary tracking-tight" data-id="element-592">
          Portfolio Allocation
        </h3>
        <button className="text-sm text-brand-purple-lighter hover:text-white transition-colors font-ui" data-id="element-593">
          View Details
        </button>
      </div>

      <div className="flex-1 flex flex-col gap-8" data-id="element-594">
        {/* Half Circle Chart - Clean Approach */}
        <div className="w-full h-32 relative flex items-end justify-center" data-id="element-595">
          <ResponsiveContainer width="100%" height="100%" data-id="element-596">
            <PieChart data-id="element-597">
              <defs data-id="element-598">
                {data.map(entry => <Fragment key={entry.name} data-id="element-599">
                    {/* Single gradient per segment - from vibrant to subtle */}
                    <linearGradient id={`gradient-${entry.name}`} x1="0" y1="0" x2="0" y2="1" data-id="element-600">
                      <stop offset="0%" stopColor={entry.color} stopOpacity="0.9" data-id="element-601" />
                      <stop offset="100%" stopColor={entry.color} stopOpacity="0.3" data-id="element-602" />
                    </linearGradient>

                    {/* Soft glow filter */}
                    <filter id={`glow-${entry.name}`} x="-50%" y="-50%" width="200%" height="200%" data-id="element-603">
                      <feGaussianBlur in="SourceGraphic" stdDeviation="6" data-id="element-604" />
                      <feColorMatrix type="matrix" values="1 0 0 0 0  0 1 0 0 0  0 0 1 0 0  0 0 0 0.6 0" data-id="element-605" />
                      <feBlend in="SourceGraphic" mode="normal" data-id="element-606" />
                    </filter>
                  </Fragment>)}
              </defs>
              <Pie data={data} cx="50%" cy="100%" startAngle={180} endAngle={0} innerRadius={60} outerRadius={90} paddingAngle={0} dataKey="value" stroke="none" data-id="element-607">
                {data.map((entry, index) => <Cell key={`cell-${index}`} fill={`url(#gradient-${entry.name})`} filter={`url(#glow-${entry.name})`} stroke={entry.color} strokeWidth={1} strokeOpacity={0.5} style={{
                filter: `drop-shadow(0 0 12px ${entry.glowColor})`
              }} data-id="element-608" />)}
              </Pie>
              <Tooltip content={({
              active,
              payload
            }) => {
              if (!active || !payload || !payload.length) return null;
              const data = payload[0];
              return <div style={{
                background: 'rgba(20, 22, 32, 0.65)',
                backdropFilter: 'blur(32px) saturate(180%)',
                WebkitBackdropFilter: 'blur(32px) saturate(180%)',
                border: '1px solid rgba(255, 255, 255, 0.08)',
                borderRadius: '20px',
                padding: '16px 20px',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.4), inset 0 1px 0 rgba(255, 255, 255, 0.08)'
              }} data-id="element-610">
                      <div style={{
                  color: '#9CA3AF',
                  fontSize: '11px',
                  marginBottom: '10px',
                  textTransform: 'uppercase',
                  letterSpacing: '0.05em',
                  fontWeight: '400'
                }} data-id="element-611">
                        {data.name}
                      </div>
                      <div style={{
                  color: '#FFFFFF',
                  fontSize: '28px',
                  fontWeight: '300',
                  letterSpacing: '-0.02em'
                }} data-id="element-612">
                        {data.value.toFixed(2)}%
                      </div>
                    </div>;
            }} cursor={false} wrapperStyle={{
              zIndex: 1000
            }} data-id="element-609" />
            </PieChart>
          </ResponsiveContainer>
          {/* Center Text */}
          <div className="absolute left-1/2 -translate-x-1/2 flex flex-col items-center pointer-events-none z-10" style={{
          bottom: '0px'
        }} data-id="element-613">
            <span className="text-3xl font-light text-text-primary font-numbers" style={{
            letterSpacing: '-0.02em'
          }} data-id="element-614">
              {investedPercent.toFixed(1)}%
            </span>
            <span className="text-xs text-text-tertiary uppercase tracking-wider font-label mt-0.5" data-id="element-615">
              Invested
            </span>
          </div>
        </div>

        {/* Legend */}
        <div className="space-y-3" data-id="element-616">
          {data.map(item => <div key={item.name} className="flex items-center justify-between px-3 py-2 rounded-lg hover:bg-background-elevated/30 transition-all duration-200 cursor-pointer group" data-id="element-617">
              <div className="flex items-center gap-3" data-id="element-618">
                <div className="relative" data-id="element-619">
                  <div className="w-3.5 h-3.5 rounded-sm flex-shrink-0 transition-all duration-200 group-hover:scale-110" style={{
                background: `linear-gradient(135deg, ${item.color} 0%, ${item.color}dd 100%)`
              }} data-id="element-620" />
                </div>
                <span className="text-sm font-medium text-text-primary group-hover:text-text-primary transition-colors" data-id="element-621">
                  {item.name}
                </span>
              </div>
              <span className="font-numbers text-sm font-semibold text-text-primary tabular-nums" data-id="element-622">
                {item.value.toFixed(2)}%
              </span>
            </div>)}
        </div>
      </div>
    </div>;
}